module.exports = __webpack_public_path__ + "static/media/7.72c17e8b.png";